// SettingsRedirect.tsx
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useWindowDimensions from '../../../../hooks/use-window-dimensions';

export const SettingsRedirect = () => {
  const { t } = useTranslation();
  const screenSize = useWindowDimensions();

  if (!screenSize.isMobile) {
    return <Navigate to="profile-details" replace />;
  }

  return (
    <div>
      <p>{t('account.web.selectASettingFromMenu')}</p>
    </div>
  );
};